import ReactCountryFlag from 'react-country-flag';
import { languages } from '@app/i18n';
import { useTranslation } from 'react-i18next';
import BasicSelectInput from '@shared/ui/forms/inputs/BasicSelectInput';

function RenderItemLanguage({ item }) {
  return (
    <div className="render-select-icon">
      <ReactCountryFlag svg countryCode={item.flag} />
      {item.label}
    </div>
  );
}

export default function LanguageSelect({ control, error }) {
  const { t } = useTranslation();

  return (
    <BasicSelectInput
      control={control}
      name="language"
      label={t('language')}
      error={error}
      data={languages}
      labelKey="label"
      valueKey="value"
      cleanable={false}
      Render={RenderItemLanguage}
    />
  );
}
